var _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 82,
    viewBox: "0 0 88 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H80C84.4183 0 88 3.58172 88 8V56C88 60.4183 84.4183 64 80 64H8C3.58172 64 0 60.4183 0 56V8Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80 4H8C5.79086 4 4 5.79086 4 8V56C4 58.2091 5.79086 60 8 60H80C82.2091 60 84 58.2091 84 56V8C84 5.79086 82.2091 4 80 4ZM8 0C3.58172 0 0 3.58172 0 8V56C0 60.4183 3.58172 64 8 64H80C84.4183 64 88 60.4183 88 56V8C88 3.58172 84.4183 0 80 0H8Z",
    fill: "url(#paint0_linear_946_129397)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7428 77.4342L32.5401 58.6046C32.7284 57.6713 33.5485 57 34.5007 57H53.2854C54.2292 57 55.0445 57.6597 55.2414 58.5827L59.2546 77.3949C59.5858 78.947 58.0639 80.248 56.5822 79.6794L44.7402 75.1354C44.279 74.9584 43.7685 74.9584 43.3072 75.1354L31.4199 79.6968C29.9476 80.2618 28.4311 78.9801 28.7428 77.4342Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.5795 58.2093C30.956 56.3425 32.5963 55 34.5006 55H53.2853C55.1728 55 56.8035 56.3195 57.1973 58.1654L61.2106 76.9776C61.8728 80.0818 58.829 82.6838 55.8656 81.5466L44.0237 77.0027L32.1363 81.5641C29.1917 82.694 26.1587 80.1305 26.7822 77.0388L30.5795 58.2093ZM53.2853 59H34.5006L30.7033 77.8296L42.5907 73.2682C43.5132 72.9142 44.5341 72.9142 45.4567 73.2682L57.2986 77.8121L53.2853 59Z",
    fill: "url(#paint1_linear_946_129397)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_946_129397)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.863 27.4431C42.5463 25.5956 45.4537 25.5956 47.137 27.4431C48.2537 28.6687 49.9818 29.1318 51.5617 28.6287C53.9433 27.8703 56.4612 29.3241 56.9952 31.7657C57.3494 33.3855 58.6145 34.6506 60.2343 35.0048C62.6759 35.5388 64.1297 38.0567 63.3713 40.4383C62.8682 42.0182 63.3313 43.7463 64.5569 44.863C66.4044 46.5463 66.4044 49.4537 64.5569 51.137C63.3313 52.2537 62.8682 53.9818 63.3713 55.5617C64.1297 57.9433 62.6759 60.4612 60.2343 60.9952C58.6145 61.3494 57.3494 62.6145 56.9952 64.2343C56.4612 66.6759 53.9433 68.1297 51.5617 67.3713C49.9818 66.8682 48.2537 67.3313 47.137 68.5569C45.4537 70.4044 42.5463 70.4044 40.863 68.5569C39.7463 67.3313 38.0182 66.8682 36.4383 67.3713C34.0567 68.1297 31.5388 66.6759 31.0048 64.2343C30.6506 62.6145 29.3855 61.3494 27.7657 60.9952C25.3241 60.4612 23.8703 57.9433 24.6287 55.5617C25.1318 53.9818 24.6687 52.2537 23.4431 51.137C21.5956 49.4537 21.5956 46.5463 23.4431 44.863C24.6687 43.7463 25.1318 42.0182 24.6287 40.4383C23.8703 38.0567 25.3241 35.5388 27.7657 35.0048C29.3855 34.6506 30.6506 33.3855 31.0048 31.7657C31.5388 29.3241 34.0567 27.8703 36.4383 28.6287C38.0182 29.1318 39.7463 28.6687 40.863 27.4431Z",
    fill: "url(#paint2_linear_946_129397)"
  }), /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 44,
    cy: 48,
    r: 16.9263,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.292 42.4409C38.6359 42.3955 41.6827 41.1197 44 39.0456C46.3173 41.1197 49.3641 42.3955 52.708 42.4409C52.8294 43.1643 52.8926 43.9074 52.8926 44.6653C52.8926 50.4731 49.1808 55.414 44 57.2452C38.8192 55.414 35.1074 50.4731 35.1074 44.6653C35.1074 43.9074 35.1706 43.1643 35.292 42.4409ZM48.1207 46.5628C48.5548 46.1287 48.5548 45.4249 48.1207 44.9908C47.6866 44.5567 46.9828 44.5567 46.5487 44.9908L42.8884 48.6511L41.4513 47.214C41.0172 46.7799 40.3133 46.7799 39.8793 47.214C39.4452 47.6481 39.4452 48.3519 39.8793 48.786L42.1024 51.0092C42.5365 51.4433 43.2403 51.4433 43.6744 51.0092L48.1207 46.5628Z",
    fill: "white"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "star star-3",
    d: "M63.0489 13.927C63.3483 13.0057 64.6517 13.0057 64.951 13.927L66.0206 17.2188C66.1545 17.6309 66.5384 17.9098 66.9717 17.9098H70.4329C71.4016 17.9098 71.8044 19.1494 71.0207 19.7188L68.2205 21.7533C67.87 22.0079 67.7233 22.4593 67.8572 22.8713L68.9268 26.1631C69.2261 27.0844 68.1717 27.8505 67.3879 27.2811L64.5878 25.2467C64.2373 24.9921 63.7627 24.9921 63.4122 25.2467L60.612 27.2811C59.8283 27.8505 58.7738 27.0844 59.0732 26.1631L60.1428 22.8713C60.2766 22.4593 60.13 22.0079 59.7795 21.7533L56.9793 19.7188C56.1956 19.1494 56.5984 17.9098 57.5671 17.9098H61.0283C61.4615 17.9098 61.8455 17.6309 61.9794 17.2188L63.0489 13.927Z",
    fill: "url(#paint3_linear_946_129397)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "star star-2",
    d: "M43.0492 7.92707C43.3485 7.00576 44.6519 7.00576 44.9513 7.92707L46.0209 11.2189C46.1547 11.6309 46.5387 11.9098 46.9719 11.9098H50.4331C51.4018 11.9098 51.8046 13.1495 51.0209 13.7189L48.2207 15.7533C47.8702 16.0079 47.7236 16.4593 47.8575 16.8713L48.927 20.1631C49.2264 21.0844 48.1719 21.8506 47.3882 21.2812L44.588 19.2467C44.2375 18.9921 43.7629 18.9921 43.4124 19.2467L40.6123 21.2812C39.8286 21.8506 38.7741 21.0844 39.0734 20.1631L40.143 16.8713C40.2769 16.4593 40.1302 16.0079 39.7797 15.7533L36.9796 13.7189C36.1958 13.1495 36.5986 11.9098 37.5673 11.9098H41.0285C41.4618 11.9098 41.8457 11.6309 41.9796 11.2189L43.0492 7.92707Z",
    fill: "url(#paint4_linear_946_129397)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "star star-1",
    d: "M23.0492 13.9271C23.3485 13.0058 24.6519 13.0058 24.9513 13.9271L26.0209 17.2189C26.1547 17.6309 26.5387 17.9098 26.9719 17.9098H30.4331C31.4018 17.9098 31.8046 19.1495 31.0209 19.7189L28.2207 21.7533C27.8702 22.0079 27.7236 22.4593 27.8575 22.8713L28.927 26.1631C29.2264 27.0844 28.1719 27.8506 27.3882 27.2812L24.588 25.2467C24.2375 24.9921 23.7629 24.9921 23.4124 25.2467L20.6123 27.2812C19.8286 27.8506 18.7741 27.0844 19.0734 26.1631L20.143 22.8713C20.2769 22.4593 20.1302 22.0079 19.7797 21.7533L16.9796 19.7189C16.1958 19.1495 16.5986 17.9098 17.5673 17.9098H21.0285C21.4618 17.9098 21.8457 17.6309 21.9796 17.2189L23.0492 13.9271Z",
    fill: "url(#paint5_linear_946_129397)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_946_129397",
    x: 18,
    y: 24,
    width: 52,
    height: 52,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0290278 0 0 0 0 0.218403 0 0 0 0 0.337639 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_946_129397"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_946_129397",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_946_129397",
    x1: -2.73965e-7,
    y1: 47.68,
    x2: 90.0185,
    y2: 36.6834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#048467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#064871"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_946_129397",
    x1: 26.7,
    y1: 74.9928,
    x2: 62.1588,
    y2: 70.9308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#048467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#064871"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_946_129397",
    x1: 20,
    y1: 59.76,
    x2: 69.4435,
    y2: 55.3673,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#048467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#064871"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_946_129397",
    x1: 56.5652,
    y1: 23.8453,
    x2: 71.8711,
    y2: 22.4254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#048467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#064871"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_946_129397",
    x1: 36.5654,
    y1: 17.8453,
    x2: 51.8714,
    y2: 16.4254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#048467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#064871"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_946_129397",
    x1: 16.5654,
    y1: 23.8453,
    x2: 31.8714,
    y2: 22.4254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#048467"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#064871"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.dce5fd881bad5e9d1ff2a6c25abd5423.svg";
export { ForwardRef as ReactComponent };